export const enum ClientType {
    'CLIENT' = 'client',
    'PROSPECT' = 'prospect',
    'SAMPLE' = 'sample'
}